(function () {
  var STORAGE_KEY = 'ciq_wishlist';
  var ACCOUNT_WISHLIST_URL = '/apps/collector-hub/wishlist';
  var remoteReady = false;
  var localRevision = 0;
  var remoteSyncTimer = null;

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    localRevision += 1;
    document.dispatchEvent(new CustomEvent('ciq:wishlist:updated', { detail: { wishlist: list } }));
  }

  function setWishlistFromAccount(list) {
    var localItems = getWishlist();
    var localById = {};
    localItems.forEach(function (item) { if (item && item.id != null) localById[String(item.id)] = item; });
    var merged = (Array.isArray(list) ? list : []).map(function (item) {
      if (!item || item.id == null) return item;
      var localItem = localById[String(item.id)];
      if (!localItem) return item;
      var next = Object.assign({}, item);
      ['image', 'edition', 'collectionTitle', 'collectionUrl', 'collectionCount', 'savedAt', 'savedPriceCents', 'referencePriceCents'].forEach(function (key) {
        if (localItem[key] != null && localItem[key] !== '') next[key] = localItem[key];
      });
      return next;
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    document.dispatchEvent(new CustomEvent('ciq:wishlist:updated', { detail: { wishlist: getWishlist(), accountSync: true } }));
  }

  function queueAccountSync() {
    if (!remoteReady) return;
    window.clearTimeout(remoteSyncTimer);
    remoteSyncTimer = window.setTimeout(function () {
      fetch(ACCOUNT_WISHLIST_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: getWishlist() })
      }).catch(function () {});
    }, 250);
  }

  function syncAccountWishlist() {
    var startingRevision = localRevision;
    fetch(ACCOUNT_WISHLIST_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Wishlist account sync unavailable');
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !Array.isArray(payload.items)) throw new Error('Invalid wishlist sync response');
        if (localRevision !== startingRevision) {
          remoteReady = true;
          queueAccountSync();
          return;
        }
        if (payload.initialized) {
          setWishlistFromAccount(payload.items);
          remoteReady = true;
          return;
        }
        remoteReady = true;
        queueAccountSync();
      })
      .catch(function () {
        // Keep the local wishlist usable when the account app is not installed or available.
      });
  }

  function normalizeProductId(productId) {
    return productId == null ? '' : String(productId);
  }

  function isWishlisted(productId) {
    var normalizedId = normalizeProductId(productId);
    return normalizedId !== '' && getWishlist().some(function (item) {
      return item && normalizeProductId(item.id) === normalizedId;
    });
  }

  function priceToCents(value) {
    var normalized = String(value || '').replace(/[^\d.,-]/g, '');
    if (normalized.indexOf(',') !== -1 && normalized.indexOf('.') !== -1) normalized = normalized.replace(/,/g, '');
    else if (normalized.indexOf(',') !== -1) normalized = normalized.replace(',', '.');
    var amount = parseFloat(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function toggleItem(btn) {
    var id = normalizeProductId(btn.dataset.productId);
    if (!id) return;
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return item && normalizeProductId(item.id) === id; });
    var added;
    if (idx > -1) {
      list.splice(idx, 1);
      added = false;
    } else {
      var inventoryTracked = btn.dataset.productInventoryTracked === 'true';
      var inventoryQuantity = inventoryTracked && btn.dataset.productInventory !== '' ? Number(btn.dataset.productInventory) : null;
      list.push({
        id: id,
        handle: btn.dataset.productHandle || '',
        title: btn.dataset.productTitle || '',
        type: btn.dataset.productType || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || '',
        savedPriceCents: priceToCents(btn.dataset.productPrice),
        savedAt: Date.now(),
        collectionTitle: btn.dataset.productCollection || '',
        collectionUrl: btn.dataset.productCollectionUrl || '',
        collectionCount: btn.dataset.productCollectionCount || '',
        inventoryTracked: inventoryTracked,
        inventoryQuantity: Number.isFinite(inventoryQuantity) ? Math.max(0, inventoryQuantity) : null,
        inventoryCheckedAt: Number.isFinite(inventoryQuantity) ? Date.now() : 0,
        variantId: btn.dataset.productVariantId || btn.dataset.variantId || '',
        available: btn.dataset.productAvailable || '',
        stockLabel: btn.dataset.productStockLabel || '',
        edition: btn.dataset.productEdition || '',
        genre: btn.dataset.productGenre || '',
        franchise: btn.dataset.productFranchise || '',
        series: btn.dataset.productSeries || '',
        character: btn.dataset.productCharacter || '',
        productNumber: btn.dataset.productNumber || '',
        release: btn.dataset.productRelease || '',
        condition: btn.dataset.productCondition || '',
        material: btn.dataset.productMaterial || '',
        height: btn.dataset.productHeight || '',
        exclusivity: btn.dataset.productExclusivity || ''
      });
      added = true;
    }
    saveWishlist(list);
    return added;
  }

  function applyState(btn, active) {
    btn.classList.toggle('is-wishlisted', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var title = btn.dataset.productTitle ? ': ' + btn.dataset.productTitle : '';
    btn.setAttribute('aria-label', (active ? 'Remove from wishlist' : 'Add to wishlist') + title);
  }

  function getAnimationImageUrl(btn) {
    if (btn.dataset.productImage) return btn.dataset.productImage;

    var card = btn.closest ? btn.closest('.ciq-product-card, [data-coreiq-main-product]') : null;
    var img = card ? card.querySelector('.ciq-product-card__media img, .ciq-main-product__media-item:not([hidden]) img, .ciq-main-product__media-item.is-active img') : null;
    if (img && img.currentSrc) return img.currentSrc;
    return img && img.src ? img.src : '';
  }

  function animateWishlist(btn) {
    var wishlistIcon = document.querySelector('.ciq-header__wishlist-btn');
    if (!wishlistIcon || !btn) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    wishlistIcon.classList.add('is-receiving');
    window.setTimeout(function () {
      wishlistIcon.classList.remove('is-receiving');
    }, reducedMotion ? 520 : 820);
    if (reducedMotion) return;

    var sourceRect = btn.getBoundingClientRect();
    var targetRect = wishlistIcon.getBoundingClientRect();
    if (!sourceRect || !targetRect) return;

    var token = document.createElement('span');
    token.className = 'ciq-cart-fly-token ciq-cart-fly-token--wishlist';
    token.setAttribute('aria-hidden', 'true');

    var imageUrl = getAnimationImageUrl(btn);
    if (imageUrl) {
      var tokenImg = document.createElement('img');
      tokenImg.src = imageUrl;
      tokenImg.alt = '';
      token.appendChild(tokenImg);
    } else {
      token.classList.add('ciq-cart-fly-token--fallback');
    }

    token.style.left = sourceRect.left + sourceRect.width / 2 - 21 + 'px';
    token.style.top = sourceRect.top + sourceRect.height / 2 - 21 + 'px';
    document.body.appendChild(token);

    var deltaX = targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
    var deltaY = targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2);

    if (token.animate) {
      token.animate(
        [
          { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
          { transform: 'translate(' + (deltaX * 0.62) + 'px, ' + (deltaY * 0.58 - 22) + 'px) scale(0.9)', opacity: 0.95 },
          { transform: 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.34)', opacity: 0.08 }
        ],
        { duration: 760, easing: 'cubic-bezier(0.18, 0.78, 0.22, 1)', fill: 'forwards' }
      ).onfinish = function () {
        token.remove();
      };
      window.setTimeout(function () {
        token.remove();
      }, 950);
    } else {
      token.remove();
    }
  }

  function syncCounts() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-coreiq-wishlist-count]').forEach(function (el) {
      el.hidden = count === 0;
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-coreiq-wishlist-btn]').forEach(function (btn) {
      applyState(btn, isWishlisted(btn.dataset.productId));
    });
    syncCounts();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-coreiq-wishlist-btn]');
    if (!btn) return;
    var added = toggleItem(btn);
    applyState(btn, added);
    if (added) animateWishlist(btn);
  });

  document.addEventListener('ciq:wishlist:updated', function (event) {
    syncAllButtons();
    if (!event.detail || !event.detail.accountSync) queueAccountSync();
  });

  syncAllButtons();
  syncAccountWishlist();

  window.CiqWishlist = { getWishlist: getWishlist, isWishlisted: isWishlisted, saveWishlist: saveWishlist };
})();
